import { useStaticQuery, graphql } from 'gatsby'

interface SidebarItemI {
  label: string
  url: string
}

interface AboutUsI {
  images: ImageInfoI[]
}

interface ImageInfoI {
  title: string
  href: string
}

interface PhoneI {
  countryCode: string
  number: string
}

export interface SocialI {
  twitter?: string
  instagram?: string
  facebook?: string
}
export interface ContactUsI extends SocialI {
  phone1: PhoneI
  phone2?: PhoneI
  email: string
  googleMap: string
}

export interface AwardsListItemI {
  title: string
  year: number
  giver: string
}

export interface RoomItemI {
  label: string
  picUrl: string
  description: string
  amenities: string[]
}

export interface FacilitiesI {
  label: string
  iconName: string
}

export interface ImageSrcI {
  thumb: string // src of thumb image
  sm: string // src of larger image to be displayed in preview
}

export interface PagePhotoSectionI {
  title: string
  images: ImageSrcI[]
}

interface LayoutConfigI {
  homeCarousel: string[]
  sidebar: SidebarItemI[]
  aboutUs: AboutUsI
  contactUs: ContactUsI
  awards: AwardsListItemI[]
  rooms: RoomItemI[]
  facilities: FacilitiesI[]
  facilitiesPreview: FacilitiesI[]
  galleryPreview: ImageSrcI[]
  photoGallery: PagePhotoSectionI[]
  restaurant: PagePhotoSectionI[]
}

export const useLayoutConfig = (): LayoutConfigI => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            layoutConfig {
              homeCarousel
              sidebar {
                label
                url
              }
              aboutUs {
                images {
                  title
                  href
                }
              }
              contactUs {
                phone1 {
                  countryCode
                  number
                }
                phone2 {
                  countryCode
                  number
                }
                email
                twitter
                instagram
                facebook
                googleMap
              }
              awards {
                title
                year
                giver
              }
              rooms {
                label
                picUrl
                description
                amenities
              }
              facilities {
                label
                iconName
              }
              facilitiesPreview {
                label
                iconName
              }
              galleryPreview {
                thumb
                sm
              }
              photoGallery {
                title
                images {
                  thumb
                  sm
                }
              }
              restaurant {
                title
                images {
                  thumb
                  sm
                }
              }
            }
          }
        }
      }
    `
  )
  return site.siteMetadata.layoutConfig
}
